import { Page, PageHeader } from '@/components/layout/Page';
import { useDateFormat } from '@/features/company/api';
import { ApplicationsPanel } from '../components/ApplicationsPanel';

export function CareersApplicationsPage() {
  const dateFormat = useDateFormat();
  return (
    <Page>
      <PageHeader
        title="Applications"
        description="Review responses from the public Jobs page and open each candidate's CRM profile."
      />
      <ApplicationsPanel dateFormat={dateFormat} />
    </Page>
  );
}
